import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import FormTalonario from './FormTalonario';

import updateTalonarioPorId from '../../../../graphql/mutations/otros/updateTalonarioPorId.graphql';
import getTalonarioPorId from '../../../../graphql/querys/otros/getTalonarioPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateTalonarioPorId, {
  name: 'updateTalonarioPorId',
})
class EditarTalonario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
    };

    this.props.client
      .query({
        query: getTalonarioPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const talonario = res.data.getTalonarioPorId;

        this.setState({
          loading: false,
          talonario: talonario,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarTalonario = this.guardarTalonario.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarTalonario(talonario) {
    this.setState(
      {
        talonario: {
          ...this.state.talonario,
          ...talonario,
        },
      },
      function() {
        let nuevoTalonario = this.state.talonario;
        delete nuevoTalonario.__typename;
        delete nuevoTalonario._id;

        if (nuevoTalonario.organismo._id) {
          nuevoTalonario.idOrganismo = nuevoTalonario.organismo._id;
          delete nuevoTalonario.organismo;
        }

        this.props
          .updateTalonarioPorId({
            variables: {
              _id: this.props.match.params.id,
              nuevoTalonario: this.state.talonario,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del talonario',
            });

            this.props.history.push('/admin/otros/talonarios');
          })
          .catch(err => {
            console.log('Error en la actualizacion del talonario');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevoTalonario: this.state.talonario,
            });
            Modal.error({
              title: 'Error en la actualizacion del talonario',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Talonario</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Talonario
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTalonario
              className="formularios"
              onSubmit={this.guardarTalonario}
              onAnterior={() =>
                this.props.history.push('/admin/otros/talonarios')
              }
              datos={this.state.talonario}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarTalonario);
